export default "__VITE_ASSET__hd_BXCx25dCCiTFVAMV3Fg__ 480w, __VITE_ASSET__XkoF7BSSbncKX_yOJhf3Ow__ 768w, __VITE_ASSET__V47HoeQBgiUEQbXS1PpE9g__ 1200w";